import React from 'react';

export const ShareIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M364.5,537a2.484,2.484,0,0,1-1.874-.861l-4.84,2.794-0.5-.866,4.847-2.8A2.493,2.493,0,1,1,364.5,537Zm-6.771,4.611,4.606,2.66A2.483,2.483,0,1,1,362,545.5c0-.087.017-0.169,0.025-0.253L357.1,542.4a2.474,2.474,0,0,1-1.6.6,2.5,2.5,0,1,1,2.5-2.5A2.473,2.473,0,0,1,357.729,541.611Z"
      transform="translate(-353 -532)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/share-icon.js